import React from 'react'
import { Grid } from 'antd-mobile'
import Icon from '../../icon'
import { getMatchMemberAvatar } from '../../features/match/model/memberAvatar'
import { getFormationLineCount, getMirroredFormationLineCount } from '../../features/match/model/formation'

const LineupView = ({ gameDetail, team, memberListInfo, onPlayerClick }) => {

    const formatPlayTime = (seconds) => {
        if (isNaN(seconds) || seconds === null || seconds === undefined) {
            return `0'`;
        } else {
            const minutes = Math.floor(seconds / 60);
            return `${minutes}'`;
        }
    };

    const getMemberImage = (user) => getMatchMemberAvatar(user, gameDetail, Icon)

    const badgeContent = (user) => {
        let result = [];
        if (user?.upDown === 1) {
            result.push(<img key={`upIcon-${user.id}`} src={Icon.UP_ICON} alt="up" style={{ width: '12px', height: '12px' }} />);
        } else if (user?.upDown === 0) {
            result.push(<img key={`downIcon-${user.id}`} src={Icon.DOWN_ICON} alt="down" style={{ width: '12px', height: '12px' }} />);
        }
        if (user?.redCardFlag) {
            const redCards = Array(user?.redCardFlag).fill().map((_, index) => (
                <img key={`redCard-${user.id}-${index}`} src={Icon.RED_CARD} alt="red" style={{ width: '14px', height: '14px' }} />
            ));
            result.push(...redCards);
        }
        if (user?.yellowCardFlag) {
            const yellowCards = Array(user?.yellowCardFlag).fill().map((_, index) => (
                <img key={`yellowCard-${user.id}-${index}`} src={Icon.YELLOW_CARD} alt="yellow" style={{ width: '11px', height: '12px', marginBottom: '1px' }} />
            ));
            result.push(...yellowCards);
        }
        return result;
    };

    const redCaptianId = gameDetail.redCaptainId;
    const greenCaptainId = gameDetail.greenCaptainId;

    const renderLine = (line, count) => {
        const userPosition = team === 1 ? gameDetail?.greenModelConfirm : gameDetail?.redModelConfirm;
        const userPositionJson = userPosition ? JSON.parse(userPosition) : null;

        // Find players for this line
        const players = [];
        for (let i = 0; i < count; i++) {
            const tempMember = userPositionJson?.find(item => item.line === line && item.team === team && item.pos === i);
            if (tempMember) {
                const fullMember = memberListInfo?.find(item => item.id === tempMember.id);
                players.push(fullMember);
            } else {
                players.push(null); // Placeholder if empty slot
            }
        }

        return players.map((tempCurrentMember, idx) => {
            if (!tempCurrentMember) return <Grid.Item key={idx} />;

            const borderColor = team === 1 ? (gameDetail?.greenColor || 'green') : (gameDetail?.redColor || 'red');
            return (
                <Grid.Item
                    key={idx}
                    className="player-chip"
                    onClick={() => onPlayerClick(tempCurrentMember)}
                >
                    <div className="pc-avatar-wrap">
                        {/* Captain / Vice-captain corner badge */}
                        {(tempCurrentMember.id === redCaptianId || tempCurrentMember.id === greenCaptainId) && (
                            <img src={Icon.CAPTAIN} alt="captain" className="pc-corner-badge pc-corner-tl" />
                        )}
                        {!(tempCurrentMember.id === redCaptianId || tempCurrentMember.id === greenCaptainId)
                            && tempCurrentMember.subCaptain === 1 && (
                                <img src={Icon.SUB_CAPTAIN} alt="sub captain" className="pc-corner-badge pc-corner-tl" />
                            )}

                        {/* Sub-in/sub-out/cards indicator (top-right) */}
                        {badgeContent(tempCurrentMember) && badgeContent(tempCurrentMember).length > 0 && (
                            <div className="pc-corner-badge pc-corner-tr pc-sub-dot">
                                {badgeContent(tempCurrentMember)}
                            </div>
                        )}

                        {/* Goal/event overlay — bottom-center, inside avatar bounds */}
                        {(() => {
                            const goalFlag = tempCurrentMember.goalFlag || 0;
                            const penaltyFlag = tempCurrentMember.penaltyFlag || 0;
                            const ownGoals = tempCurrentMember.ownGoalFlag || 0;
                            const missed = tempCurrentMember.penaltyNotFlag || 0;
                            if (goalFlag === 0 && penaltyFlag === 0 && ownGoals === 0 && missed === 0) return null;
                            return (
                                <div className="pc-goal-badge">
                                    {goalFlag > 0 && (
                                        <span className="pc-goal-item">
                                            <img src={Icon.GOAL} alt="goal" className="pc-goal-icon" />
                                            {goalFlag > 1 && <b>×{goalFlag}</b>}
                                        </span>
                                    )}
                                    {penaltyFlag > 0 && (
                                        <span className="pc-goal-item">
                                            <img src={Icon.PENALTY_KICK} alt="penalty" className="pc-goal-icon" />
                                            {penaltyFlag > 1 && <b>×{penaltyFlag}</b>}
                                        </span>
                                    )}
                                    {ownGoals > 0 && (
                                        <span className="pc-goal-item pc-goal-own">
                                            <img src={Icon.OWN_GOAL} alt="og" className="pc-goal-icon" />
                                        </span>
                                    )}
                                    {missed > 0 && (
                                        <span className="pc-goal-item pc-goal-miss">
                                            <img src={Icon.PENALTY_NOT_SCORED} alt="miss" className="pc-goal-icon" />
                                        </span>
                                    )}
                                </div>
                            );
                        })()}

                        {/* Avatar */}
                        <img
                            src={getMemberImage(tempCurrentMember)}
                            className="player-chip-avatar"
                            alt={tempCurrentMember.name}
                            style={{ width: '44px', height: '44px', border: `2px solid ${borderColor}` }}
                        />

                        {/* Playtime badge in bottom left (GameHistoryDetail Specific) */}
                        <span style={{
                            position: 'absolute',
                            bottom: '10px',
                            left: '-10px',
                            width: '20px', height: '20px',
                            zIndex: 10,
                            // 球场背景上的上场时间也保持白字黑色发光，和球员姓名一致。
                            color: '#fff',
                            fontWeight: '900',
                            textShadow: "0 1px 2px rgba(0,0,0,1), 0 0 4px rgba(0,0,0,0.95), 0 0 8px rgba(0,0,0,0.88)",
                            fontStyle: 'italic'
                        }}>
                            {formatPlayTime(tempCurrentMember.playTime)}
                        </span>
                    </div>
                    {/* Name (with optional injury icon prefix) */}
                    <div className="player-chip-name">
                        {tempCurrentMember.injured === 1 && (
                            <img src={Icon.SHOUSHANG} alt="injured" className="pc-name-injury-icon" />
                        )}{tempCurrentMember.name}
                    </div>
                </Grid.Item>
            )
        })
    }

    const grids = [];
    for (let i = 1; i <= 4; i++) {
        let tempCount;
        if (team === 1) {
            tempCount = getFormationLineCount(gameDetail?.greenModel, i)
        } else {
            tempCount = getMirroredFormationLineCount(gameDetail?.redModel, i)
        }
        grids.push(
            <Grid key={`grid-${i}`} columns={tempCount ? tempCount : 1} style={{ width: '100%', marginBottom: '10px' }}>
                {renderLine(i, tempCount)}
            </Grid>
        );
    }
    return <div style={{ width: '100%' }}>{grids}</div>
}

export default LineupView
